import { render, staticRenderFns } from "./produkt_porovnanie_balikov.vue?vue&type=template&id=183471de&"
import script from "./produkt_porovnanie_balikov.vue?vue&type=script&lang=js&"
export * from "./produkt_porovnanie_balikov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183471de')) {
      api.createRecord('183471de', component.options)
    } else {
      api.reload('183471de', component.options)
    }
    module.hot.accept("./produkt_porovnanie_balikov.vue?vue&type=template&id=183471de&", function () {
      api.rerender('183471de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/produkt_porovnanie_balikov.vue"
export default component.exports